<template>
  <div class="div-dropdown-component">
    <SingleSelectInteger
      class="form"
      :options="optionsVehicleBrand"
      :value.sync="compValue"
      :value-property="'value'"
      :disabled="readonly"
    />
    <span v-if="modelstate.length > 0" class="text-danger">
      {{ modelstate }}
    </span>
  </div>
</template>

<script>
export default {
  name: "BrandVehicleDropdown",
  components: {
    "SingleSelectInteger": () => import("@/components_rms/base/SingleSelectInteger.vue"),
  },
  props: {
    brandVehicleId: Number,
    readonly: Boolean,
  },
  data() {
    return {
      modelstate: {},
      optionsVehicleBrand: [],
    };
  },
  created() {
    this.getListbrand();
  },
  computed: {
    compValue: {
      get: function () {
        return this.brandVehicleId;
      },
      set: function (newValue) {
        this.$emit("update:brandVehicleId", parseInt(newValue));
      },
    },
  },
  methods: {
    getListbrand() {
      this.modelstate = {};
      this.$apiScheduler
        .get("/brand/list/")
        .then((response) => {
          this.optionsVehicleBrand = response.data.map((item) => ({
            value: parseInt(item.id),
            text: item.name,
          }));
        })
        .catch((error) => {
          if (error.response.status == 400) {
            this.modelstate = error.response.data.errors;
          }
        });
    },
  },
};
</script>